import React from 'react';
const ReportStatus = ({ statusText }) => {
    const getStatusClasses = (statusText) => {
        switch (statusText) {
            case 'Finished':
                return 'bg-green-100 text-green-800';
            case 'Started':
                return 'bg-gray-100 text-gray-800';
            case 'Generating':
                return 'bg-yellow-100 text-yellow-800';
            case 'Error':
                return 'bg-red-100 text-red-800';
            default:
                return 'bg-gray-100 text-gray-800'; // default style
        }
    };
    return (
        <span
            className={`inline-flex items-center px-2 py-0.5 text-[10px] font-bold rounded-full ${getStatusClasses(statusText)}`}
        >
            {statusText.toUpperCase()} {/* Capitalize first letter */}
        </span>
    );
};

export default ReportStatus;
